import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Crown, MagnifyingGlass } from "@phosphor-icons/react";
import api from "@/lib/api";

export function PremiumAdmin() {
  const [data, setData] = useState(null);
  const [q, setQ] = useState("");
  const [filter, setFilter] = useState("all"); // all | premium | standard
  const load = () => api.get("/admin/premium/users").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const setP = async (uid, enabled, duration) => {
    try { await api.put(`/admin/premium/${uid}`, { enabled, duration }); toast.success("Aktualisiert"); load(); }
    catch { toast.error("Fehler"); }
  };
  if (!data) return null;

  const s = q.trim().toLowerCase();
  const filtered = data.users.filter((u) => {
    if (filter === "premium" && !u.premium) return false;
    if (filter === "standard" && u.premium) return false;
    if (s && !((u.email || "").toLowerCase().includes(s) || (u.name || "").toLowerCase().includes(s))) return false;
    return true;
  });

  const FILTERS = [["all", `Alle (${data.total})`], ["premium", `Premium (${data.active_premium})`], ["standard", `Standard (${data.total - data.active_premium})`]];

  return (
    <div className="sb-card p-5" data-testid="admin-premium">
      <h2 className="font-heading font-semibold flex items-center gap-2"><Crown weight="fill" style={{ color: "#F59E0B" }} />Premium-Verwaltung</h2>
      <p className="text-xs text-gray-500 mb-3" data-testid="premium-count">{data.active_premium} von {data.total} Nutzern haben Premium aktiv</p>

      <div className="relative mb-2">
        <MagnifyingGlass size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
        <input data-testid="premium-search" className="sb-input pl-9" placeholder="Nutzer suchen (Name / E-Mail)" value={q} onChange={(e) => setQ(e.target.value)} />
      </div>
      <div className="flex flex-wrap gap-1.5 mb-3" data-testid="premium-filters">
        {FILTERS.map(([v, l]) => (
          <button key={v} data-testid={`premium-filter-${v}`} onClick={() => setFilter(v)}
            className={`px-2.5 py-1 rounded-full text-xs font-heading border-2 ${filter === v ? "text-white border-gray-800" : "bg-white text-gray-600 border-gray-300"}`}
            style={filter === v ? { background: "var(--app-primary)" } : {}}>{l}</button>
        ))}
      </div>

      {filtered.length === 0 && <p className="font-body text-sm text-gray-500" data-testid="premium-empty">Keine Nutzer gefunden.</p>}
      <div className="space-y-2 max-h-[28rem] overflow-y-auto">
        {filtered.map((u, i) => (
          <div key={u.user_id} data-testid={`premium-row-${i}`} className="border-2 border-gray-800 rounded-xl px-3 py-2 bg-white">
            <div className="flex items-center justify-between gap-2">
              <div className="min-w-0">
                {u.name && <span className="text-sm font-heading block truncate">{u.name}</span>}
                <span className="text-xs text-gray-500 truncate block">{u.email}</span>
              </div>
              <span className="text-[10px] px-2 py-0.5 rounded-full text-white shrink-0" style={{ background: u.premium ? "#22C55E" : "#9CA3AF" }} data-testid={`premium-status-${i}`}>{u.premium ? "Premium" : "Standard"}</span>
            </div>
            {u.premium && u.premium_until && <p className="text-[11px] text-gray-400 mt-0.5">bis {new Date(u.premium_until).toLocaleDateString("de-DE")}{u.premium_source ? ` · ${u.premium_source}` : ""}</p>}
            <div className="flex flex-wrap gap-1.5 mt-1.5">
              {u.premium ? (
                <button data-testid={`premium-off-${i}`} onClick={() => setP(u.user_id, false)} className="text-xs px-2 py-1 rounded-lg border-2 border-gray-800 bg-white">Deaktivieren</button>
              ) : (
                <>
                  <button data-testid={`premium-7-${i}`} onClick={() => setP(u.user_id, true, "7")} className="text-xs px-2 py-1 rounded-lg border-2 border-gray-800 bg-white">7 Tage</button>
                  <button data-testid={`premium-30-${i}`} onClick={() => setP(u.user_id, true, "30")} className="text-xs px-2 py-1 rounded-lg border-2 border-gray-800 bg-white">30 Tage</button>
                  <button data-testid={`premium-unl-${i}`} onClick={() => setP(u.user_id, true, "unlimited")} className="text-xs px-2 py-1 rounded-lg text-white" style={{ background: "var(--app-primary)" }}>Unbegrenzt</button>
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
